import React from 'react';
import SHLEHeader from './SHLEHeader';
import AssessmentHeader from './AssessmentHeader';
import { useBasicDetails } from '../../store/storeApi';

/** Header Component */
const Header = (): JSX.Element => {
  const {
    headerOptions: { isAssessment },
  } = useBasicDetails();
  return <>{!isAssessment ? <SHLEHeader /> : <AssessmentHeader />}</>;
};

export default Header;
